import { jsx } from 'react/jsx-runtime';
import { DatePicker } from '@dls/web';
import { buildErrorMessage } from './helpers/utils.js';
import CustomController from './CustomController.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
const DateRangePickerController = _a => {
  var _b = _a,
    {
      name,
      control,
      rules,
      shouldUnregister,
      defaultValue
    } = _b,
    datePickerProps = __objRest(_b, ["name", "control", "rules", "shouldUnregister", "defaultValue"]);
  const {
    bgColor = "haze",
    label
  } = datePickerProps;
  return /* @__PURE__ */jsx(CustomController, {
    name,
    control,
    rules,
    shouldUnregister,
    defaultValue,
    render: _a2 => {
      var _b2 = _a2,
        {
          field: _c
        } = _b2,
        _d = _c,
        {
          onChange
        } = _d,
        field = __objRest(_d, ["onChange"]),
        {
          fieldState: {
            error
          }
        } = _b2;
      const errorMessage = buildErrorMessage({
        error,
        label,
        rules
      });
      return /* @__PURE__ */jsx(DatePicker.DateRangePicker, __spreadProps(__spreadValues(__spreadValues({}, field), datePickerProps), {
        bgColor,
        defaultValue,
        error: !!errorMessage,
        hintMessage: errorMessage,
        onConfirm: val => {
          var _a3;
          if (Array.isArray(val)) {
            return;
          }
          let dateRange;
          if (val instanceof Date) {
            dateRange = {
              from: val,
              to: val
            };
          } else {
            dateRange = val;
          }
          onChange(dateRange);
          (_a3 = datePickerProps.onConfirm) == null ? void 0 : _a3.call(datePickerProps, dateRange);
        },
        onChange: val => {
          var _a3;
          const dateRange = __spreadProps(__spreadValues({}, val), {
            to: (val == null ? void 0 : val.to) || (val == null ? void 0 : val.from)
          });
          onChange(dateRange);
          (_a3 = datePickerProps.onChange) == null ? void 0 : _a3.call(datePickerProps, dateRange);
        },
        onClear: () => {
          var _a3;
          onChange(void 0);
          (_a3 = datePickerProps.onClear) == null ? void 0 : _a3.call(datePickerProps);
        }
      }));
    }
  });
};
export { DateRangePickerController as default };